import * as THREE from 'three'

export default function buildDepthMaterial(uniforms){
  
  const depthMaterial = new THREE.MeshDepthMaterial({
    depthPacking: THREE.RGBADepthPacking,
  })

  depthMaterial.onBeforeCompile = (shader) =>
  {
    // Uniforms
    shader.uniforms.uMouse = uniforms.uMouse

    shader.vertexShader = shader.vertexShader.replace(
      '#include <common>', 
      `
      #include <common>

      uniform vec3 uMouse;
      uniform float uTime;

      attribute vec3 aPos;
      attribute vec3 aCenter;
      `
    )
    shader.vertexShader = shader.vertexShader.replace(
      '#include <begin_vertex>',
      `
        #include <begin_vertex>

        // Ditance
        float distanceX = uMouse.x - aPos.x;
        float distanceY = uMouse.y - aPos.y;
        float distanceZ = uMouse.z - aPos.z;

        // Factor
        float factor = pow(1.8, -abs(distanceX) + -abs(distanceY) + -abs(distanceZ)) * 2.0;
        factor = pow(factor, 2.0);
        
        // Scale
        float distanceTime = (sin(uTime * 0.001) * 0.2) + 2.0;
        float scale = factor * distanceTime < 0.85 ? factor * distanceTime : 0.85;

        transformed.x += (aCenter.x - transformed.x) * scale;
        transformed.y += (aCenter.y - transformed.y) * scale;
        transformed.z += (aCenter.z - transformed.z) * scale;

        // Translate
        transformed.x += -distanceX * factor * distanceTime;
        transformed.y += -distanceY * factor * distanceTime;
        transformed.z += -distanceZ * factor * distanceTime;
      `
    )
  }

  return depthMaterial
}
